<div class="flex flex-col items-center lg:py-4" *ngIf="loading && !addressVerification">
    <h3 class="md:text-2xl mb-2 font-semibold" [ngClass]="hasWhiteBackground ? 'text-black' : 'text-white'">
        Please wait while we fetch your packages...
    </h3>
    <mat-spinner
      diameter="72"
      [ngStyle]="{
        '--mdc-circular-progress-active-indicator-color': hasWhiteBackground ? '#423473' : '#FFFFFF'
      }">
    </mat-spinner>
</div>
<div class="flex flex-col items-center py-12" *ngIf="loading && addressVerification">
    <h3 class="text-2xl text-black mb-2 font-semibold">
        Please wait while we verify your address...
    </h3>
    <!-- <mat-spinner id="test" class="test" diameter="72"></mat-spinner> -->
</div>

<div *ngIf="!loading" class="w-full flex flex-col justify-center items-center">

    <!-- OLD FEASIBILITY BUTTON -->

    <!-- <fuse-card class="rounded-full bg-white p-4 mt-4 w-full max-w-6/10">
        <div class="flex flex-row border-gray-300 justify-between items-center w-full">
            <div class="w-full">
                 address entered doesn't contain a street number and/or street name
                <input style="background-image: url('./assets/icons/location.png');
                background-position: 10px 10px; 
                background-repeat: no-repeat;size: 10px;" class="w-fullç" id="searchTextField" #searchInput type="text" placeholder="Where do you need internet?" />
            </div>
            <div class="flex flex-row justify-center items-center w-1/8 mr-4" *ngIf="!isScreenSmall && !addressVerification">
                <button class="feasibility-button" (click)="btn_getLocation()">Show me my deals</button>
            </div>
        </div>
    </fuse-card> -->




    <!-- ------------------------ Address Verification ------------------------- -->
    <!-- 
<div *ngIf="addressVerification" class="location-search-wrapper">
    <input type="text" placeholder="Where do you need internet?" id="searchTextField" #searchInput/>
  </div> -->

    <!-- ------------------------------ Installation Address ------------------------------ -->

        <div *ngIf="installationAddress" class="relative flex justify-center items-center w-full max-w-4xl mx-auto h-12 sm:h-14 md:h-16 border border-gray-300 rounded-full pl-8 sm:pl-10 pr-2 sm:pr-2.5 bg-white shadow-md">
            <span *ngIf="!addressVerification" class="absolute left-2 sm:left-3 h-full flex items-center">
                <img src="./assets/icons/location_pin.png" alt="Location Icon" class="w-4 h-4 sm:w-5 sm:h-5" />
            </span>
            <input
                [ngClass]="!addressVerification ? 'placeholder:text-[#3F2A79] placeholder:text-sm sm:placeholder:text-base' : 'placeholder:text-secondary'"
                placeholder="Enter your location"
                id="searchTextField"
                autofocus
                #searchInput
                class="w-full border-none p-2 sm:p-2.5 outline-none text-sm sm:text-base font-bold text-[#3F2A79] flex-1 min-w-0" />
            <button *ngIf="!addressVerification"
                class="inline-flex items-center justify-center relative whitespace-nowrap outline-2 outline-transparent outline-offset-2 leading-[1.2] h-8 sm:h-10 md:h-12 rounded-full font-bold px-3 sm:px-4 md:px-6 text-[#423473] bg-[#FFCB1D] text-xs sm:text-sm md:text-base border border-[#423473] drop-shadow-sm flex-shrink-0 ml-2"
                (click)="installation_btn_getLocation('new')">
                <span class="text-[#1F1E21] font-semibold">
                    <span class="hidden sm:inline">Show me my deals</span>
                    <span class="sm:hidden">Find deals</span>
                </span>
            </button>
        </div>
        <div *ngIf="installationAddress" class="text-center mt-3 sm:mt-4 text-sm sm:text-base w-full flex justify-center px-4">
            <h3 class="text-center text-sm sm:text-base w-fit mt-2 sm:mt-3"
                [ngClass]="{ 'text-white': !hasWhiteBackground, 'text-[#2B2B2B]': hasWhiteBackground }">
                <p class="cursor-pointer" (click)="btn_getLocation()">
                or <span class="underline underline-offset-1 cursor-pointer">use my current location</span>
                </p>
            </h3>
        </div>


    <!-- ------------------------------ Dashboard ------------------------------ -->

    <div *ngIf="!installationAddress" class="location-search-wrapper justify-center items-center w-full">
        <span *ngIf="!addressVerification" class="icon">
            <img src="./assets/icons/location_pin.png" alt="Location Icon" />
        </span>
        <input
            [ngClass]="!addressVerification ? 'placeholder:text-[#3F2A79]' : 'placeholder:text-secondary'"
            placeholder="Enter your location" id="searchTextField" autofocus #searchInput />
        <button *ngIf="!addressVerification" class="feasibility-button drop-shadow-sm" (click)="btn_getLocation()"><span
                class="text-[#1F1E21] font-semibold px-3 max-sm:px-0 max-sm:text-xs">Show me my deals</span></button>
    </div>

    <!--
        Icon <img class="w-4 hover:cursor-pointer" src="./assets/icons/location.png" (click)="btn_getLocation()">
    -->

    <div *ngIf="addressVerification">
        <div *ngIf="!isValidAddress && searchInputValue.trim()"
            class="py-3 w-full flex flex-col justify-center items-center">
            <p class="text-red-500 text-sm">
                The address entered doesn't contain a street number and/or street name</p>
        </div>
        <div class="w-full flex justify-center items-center pt-8">
            <button [disabled]="!isValidAddress" class="text-md disabled:bg-secondary bg-accent font-bold w-fit"
                mat-flat-button [color]="'accent'" mat-button (click)="invokeEvent()">
                Update Address
            </button>
        </div>
    </div>

    <div *ngIf="!addressVerification && !installationAddress" class="text-center mt-4 text-base w-full flex justify-center">
        <h3 class="text-center text-base w-fit mt-3"
            [ngClass]="{ 'text-white': !hasWhiteBackground, 'text-[#2B2B2B]': hasWhiteBackground }">
            <p class="cursor-pointer" (click)="btn_getLocation()">
                or <span class="underline underline-offset-1 cursor-pointer">use my current location</span>
            </p>
        </h3>
    </div>
</div>